export default __webpack_public_path__ + "static/media/c-plain.c48f23d2.svg";